import React from 'react'
import numbro from 'numbro';
export const DatosNombramientos = ({empleado}) => {

    const {sueldo, tipoEmpleado,programa} = empleado ?? {};
  return (
    <div className=" container mt-2 pt-3 pb-2 mb-2 border ">
    <div className="row ">
        <div className="col ">
            <div className="col-md-12 ">
                <label className="fw-bold">Sueldo</label>
            </div>
            <div className="col-md-12 ">
                {/* <label className="">RD$ {numbro(Number.isFinite(Number(sueldo)) ? Number(sueldo) : 0).format({thousandSeparated: true})}</label> */}
                <input type="text" readOnly className="form-control" defaultValue={`RD$ ${numbro(Number.isFinite(Number(sueldo)) ? Number(sueldo) : 0).format({thousandSeparated: true})}`}></input>
            </div>
        </div>
        <div className="col ">
            <div className="col-md-12 ">
                <label className="fw-bold">Tipo Empleado</label>
            </div>
            <div className="col-md-12 text-center">
                {/* <label className="">{tipoEmpleado?.tipo ?? 'Sin especificar'}</label> */}
                <input type="text" readOnly className="form-control" defaultValue={tipoEmpleado?.tipo ?? 'Sin especificar'}></input>
            </div>
        </div>
        <div className="col ">
            <div className="col-md-12 ">
                <label className="fw-bold">Programa</label>
            </div>
            <div className="col-md-12 text-center">
                {/* <label className="">{programa?.programa ?? 'Sin especificar'}</label> */}
                <input type="text" readOnly className="form-control" defaultValue={programa?.programa ?? 'Sin especificar'}></input>
            </div>
        </div>
    </div>
</div>
  )
}

export default DatosNombramientos